var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29361",
    "data-name": "Rectangle 29361",
    width: 22,
    height: 22,
    rx: 4,
    transform: "translate(670 731)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_701",
    "data-name": "Mask Group 701",
    transform: "translate(-670 -731)",
    clipPath: "url(#facebook)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook",
    transform: "translate(670 731)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12108",
    "data-name": "Path 12108",
    d: "M20.786,0H1.213A1.214,1.214,0,0,0,0,1.214V20.787A1.214,1.214,0,0,0,1.214,22H20.786A1.214,1.214,0,0,0,22,20.786h0V1.213A1.214,1.214,0,0,0,20.786,0Zm0,0",
    fill: "#4267b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12109",
    "data-name": "Path 12109",
    d: "M15.189,22V13.492h2.868l.43-3.33h-3.3V8.041c0-.962.267-1.617,1.646-1.617h1.748V3.453a23.5,23.5,0,0,0-2.562-.131c-2.535,0-4.27,1.547-4.27,4.389v2.451H8.895v3.33h2.857V22Zm0,0",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b72c3d038b05ce8a602a6947f83310d3.svg";
export { ForwardRef as ReactComponent };